import { LocaleConfig } from '../interface';
import messages from './en-US.json';

export const EnLang: LocaleConfig = {
  messages,
  slug: 'en',
};
